import { Injectable, signal } from '@angular/core';
import { SocketService } from '@core/services/socket.service';
import { LiveBet } from '../interfaces/live-bet.interface';

@Injectable({
  providedIn: 'root',
})
export class LiveBetsService {
  liveBets = signal<LiveBet[]>([]);

  constructor(private socketService: SocketService) {
    this.socketService.socket.on('load_live_bets', (data: LiveBet[]) => {
      this.liveBets.set(data);
    });

    this.socketService.socket.on('add_live_bet', (data: LiveBet) => {
      const MAX_COUNT = 200;

      this.liveBets.update((bets) => {
        const newBets = [...bets, data];

        if (newBets.length > MAX_COUNT) {
          return newBets.slice(0, MAX_COUNT);
        }

        return newBets;
      });
    });
  }
}
